import React, { useEffect, useState } from 'react'
import { get, isEmpty, remove } from 'lodash'
import { getFinancesAccounts } from '../../../apis/finances/auth'
import NoData from '../../../components/NoData/NoData'
import ScrapingHistoryTable from './Component/ScrapingHistoryTable'
import { translation } from '../../../utils/translator'
import { classnames } from '../../../utils/text'
import { ORG_CD_TYPE } from '../../../constants/SCRAPING_DATA'
import Button from '../../../components/Button'
import SVG from "react-inlinesvg";
import arrowBoxIcon from "../../../assets/images/icon/arrow-box-icon.svg";
import { forEach } from 'lodash-es'

const ScrapingHistory = ({ permission, runReload }) => {
  const [accountList, setAccountList] = useState([])
  const [isOpen, setIsOpen] = useState([])

  useEffect(() => {
    getScrappingAccountList()
  }, [runReload])

  // 스크래핑 되어있는 리스트 호출
  const getScrappingAccountList = async () => {
    let accounts = [
      { orgCd: 'cardsales', financeScrapings: [] },
      { orgCd: 'hometax', financeScrapings: [] },
      { orgCd: 'card', financeScrapings: [] },
      { orgCd: 'ccd', financeScrapings: [] },
      { orgCd: 'pbk', financeScrapings: [] },
      { orgCd: 'cbk', financeScrapings: [] },
    ];
    const cardSales = await getFinancesAccounts("cardsales")
    const hometax = await getFinancesAccounts("hometax")
    const card = await getFinancesAccounts("card")
    const ccd = await getFinancesAccounts("ccd")
    const pbk = await getFinancesAccounts("pbk")
    const cbk = await getFinancesAccounts("cbk")

    forEach(accounts, account => {
      switch (account.orgCd) {
        case 'cardsales':
          account.financeScrapings.push(...get(cardSales, 'data.accounts[0].financeScrapings', []))
          break;
        case 'hometax':
          account.financeScrapings.push(...get(hometax, 'data.accounts[0].financeScrapings', []))
          break;
        case 'card':
          const cardList = get(card, 'data.accounts', [])
          if (!isEmpty(cardList)) {
            forEach(cardList, c => {
              //account.financeScrapings.push(...get(c, 'financeScrapings', []))
              const cardDatas = get(c, 'financeScrapings', [])
              forEach(cardDatas, data => {
                if (data.isUsing === 1) {
                  account.financeScrapings.push(data)
                }
              })
            })
          }
          break;
        case 'ccd':
          const ccdList = get(ccd, 'data.accounts', [])
          if (!isEmpty(ccdList)) {
            forEach(ccdList, c => {
              // account.financeScrapings.push(...get(c, 'financeScrapings', []))
              const ccdDatas = get(c, 'financeScrapings', [])
              forEach(ccdDatas, data => {
                if (data.isUsing === 1) {
                  account.financeScrapings.push(data)
                }
              })
            })
          }
          break;
        case 'pbk':
          const pbkList = get(pbk, 'data.accounts', [])
          if (!isEmpty(pbkList)) {
            forEach(pbkList, bk => {
              // account.financeScrapings.push(...get(bk, 'financeScrapings', []))
              const pbkDatas = get(bk, 'financeScrapings', [])
              forEach(pbkDatas, data => {
                if (data.isUsing === 1) {
                  account.financeScrapings.push(data)
                }
              })
            })
          }
          break;
        case 'cbk':
          const cbkList = get(cbk, 'data.accounts', [])
          if (!isEmpty(cbkList)) {
            forEach(cbkList, bk => {
              // account.financeScrapings.push(...get(bk, 'financeScrapings', []))
              const cbkDatas = get(bk, 'financeScrapings', [])
              forEach(cbkDatas, data => {
                if (data.isUsing === 1) {
                  account.financeScrapings.push(data)
                }
              })
            })
          }
          break;
        default:
          break;
      }
    })
    remove(accounts, (o) => isEmpty(o.financeScrapings))

    setIsOpen(accounts.map((account, idx) => ({
      idx,
      isOpen: true
    })))
    setAccountList(accounts)
  }

  return (
    <div className="scraping-history-page">
      {!isEmpty(accountList) ?
        accountList.map((account, idx) => (
          <React.Fragment key={idx}>
            <div className="scraping-history">
              <Button
                className={classnames("toggle-button p-0", {
                  closed: !isOpen[idx].isOpen,
                })}
                color="text"
                size="x-sm"
                label={<SVG src={arrowBoxIcon} />}
                onClick={() => {
                  let newArray = [...isOpen]
                  newArray[idx] = {
                    ...newArray[idx],
                    isOpen: !newArray[idx].isOpen
                  }
                  setIsOpen(newArray)
                }}
              />
              <label className="section-title">{translation(ORG_CD_TYPE, account.orgCd)}</label>
              <div className={classnames("section-table", { closed: !isOpen[idx].isOpen })}>
                {account.financeScrapings.map((item, index) => (
                  <div className="scraping-history-table-wrap" key={index}>
                    <ScrapingHistoryTable
                      permission={permission}
                      scrapingData={item}
                      orgCd={account.orgCd}
                    />
                  </div>
                ))}
              </div>
            </div>
          </React.Fragment>
        ))
        :
        <NoData />}
    </div>
  )
}

export default ScrapingHistory;